export default {
    header: {
        self: {},
        items: [{}],
    },
    aside: {
        self: {},
        items: [
            {
                title: "Dashboard",
                root: true,
                icon: "fas fa-tachometer-alt",
                page: "dashboard",
                bullet: "dot",
            },
            {
                title: "Contratos",
                root: true,
                icon: "fas fa-file-signature",
                page: "contrato",
                bullet: "dot",
            },
            {
                title: "Eventos",
                root: true,
                icon: "fas fa-car-crash",
                page: "evento",
                bullet: "dot",
            },
            {
                title: "Financeiro",
                root: true,
                icon: "fas fa-dollar-sign",
                page: "fatura",
                bullet: "dot",
            },
            {
                title: "Relatório de comissão",
                root: true,
                icon: "fas fa-chart-pie",
                page: "relatorio/relatorio01",
                bullet: "dot",
            },
        ],
    },
};
